var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 107,
    viewBox: "0 0 109 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2374_8907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51149 0.000488281H104.5C101.41 1.04949 96.6642 5.17267 94.6774 7.10314L11.5747 89.2753C6.17246 94.7028 4.65427 97.6471 4.51149 98.7134V99.0005C4.49675 98.9275 4.4956 98.8321 4.51149 98.7134V0.000488281Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51149 0.000488281H104.5C101.41 1.04949 96.6642 5.17267 94.6774 7.10314L11.5747 89.2753C6.17246 94.7028 4.65427 97.6471 4.51149 98.7134V99.0005C4.49675 98.9275 4.4956 98.8321 4.51149 98.7134V0.000488281Z",
    fill: "#FFCC46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51149 0.000488281H104.5C101.41 1.04949 96.6642 5.17267 94.6774 7.10314L11.5747 89.2753C6.17246 94.7028 4.65427 97.6471 4.51149 98.7134V99.0005C4.49675 98.9275 4.4956 98.8321 4.51149 98.7134V0.000488281Z",
    fill: "url(#paint0_linear_2374_8907)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2374_8907",
    x: 0.5,
    y: 0.000488281,
    width: 108,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2374_8907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2374_8907",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2374_8907",
    x1: 99.5,
    y1: 0.000492049,
    x2: 4.49999,
    y2: 92.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1722"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestBg);
export default __webpack_public_path__ + "static/media/best-bg.92688a314a6b26ee1d7193c028b4ecf6.svg";
export { ForwardRef as ReactComponent };